var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowserWindow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_12---Tradng-Screen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_83_",
    d: "m477.867 51.2h-443.734c-18.851 0-34.133 15.282-34.133 34.133v341.333c0 18.852 15.282 34.134 34.133 34.134h443.733c18.851 0 34.133-15.282 34.133-34.133v-341.334c.001-18.851-15.281-34.133-34.132-34.133zm-2.501 173.167-34.133-34.133c-3.332-3.331-8.734-3.331-12.066 0l-79.3 79.3-36.634-36.634c-3.332-3.331-8.734-3.331-12.066 0l-70.767 70.767-28.1-28.1c-3.332-3.331-8.734-3.331-12.066 0l-53.7 53.7v-192.734h358.4v204.8h-346.335l47.667-47.667 28.1 28.1c3.332 3.331 8.734 3.331 12.066 0l70.767-70.767 36.634 36.634c3.332 3.331 8.734 3.331 12.066 0l79.3-79.3 28.1 28.1c3.348 3.234 8.671 3.188 11.962-.104 3.293-3.291 3.339-8.614.105-11.962zm-441.233-156.1h443.733c9.426 0 17.067 7.641 17.067 17.067v34.133h-477.866v-34.134c0-9.425 7.641-17.066 17.066-17.066zm-17.066 358.4v-290.134h102.4v307.2h-85.334c-9.425 0-17.066-7.641-17.066-17.066zm460.8 17.066h-341.334v-85.333h358.4v68.267c0 9.425-7.641 17.066-17.066 17.066z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_4_",
    cx: 42.667,
    cy: 93.867,
    r: 8.533
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3_",
    cx: 76.8,
    cy: 93.867,
    r: 8.533
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2_",
    cx: 110.933,
    cy: 93.867,
    r: 8.533
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_82_",
    d: "m42.667 179.2h51.2c4.713 0 8.533-3.821 8.533-8.533 0-4.713-3.821-8.533-8.533-8.533h-51.2c-4.713 0-8.533 3.821-8.533 8.533-.001 4.713 3.82 8.533 8.533 8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_81_",
    d: "m42.667 213.333h25.6c4.713 0 8.533-3.821 8.533-8.533 0-4.713-3.82-8.533-8.533-8.533h-25.6c-4.713 0-8.533 3.821-8.533 8.533-.001 4.713 3.82 8.533 8.533 8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_80_",
    d: "m93.867 230.4h-51.2c-4.713 0-8.533 3.821-8.533 8.533 0 4.713 3.821 8.533 8.533 8.533h51.2c4.713 0 8.533-3.821 8.533-8.533s-3.821-8.533-8.533-8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_79_",
    d: "m42.667 281.6h25.6c4.713 0 8.533-3.82 8.533-8.533s-3.82-8.533-8.533-8.533h-25.6c-4.713 0-8.533 3.82-8.533 8.533s3.82 8.533 8.533 8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_78_",
    d: "m93.867 298.667h-51.2c-4.713 0-8.533 3.82-8.533 8.533s3.821 8.533 8.533 8.533h51.2c4.713 0 8.533-3.82 8.533-8.533s-3.821-8.533-8.533-8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_77_",
    d: "m42.667 349.867h25.6c4.713 0 8.533-3.821 8.533-8.533s-3.82-8.533-8.533-8.533h-25.6c-4.713 0-8.533 3.82-8.533 8.533s3.82 8.533 8.533 8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_76_",
    d: "m93.867 366.933h-51.2c-4.713 0-8.533 3.821-8.533 8.533 0 4.713 3.821 8.533 8.533 8.533h51.2c4.713 0 8.533-3.821 8.533-8.533s-3.821-8.533-8.533-8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_75_",
    d: "m68.267 401.067h-25.6c-4.713 0-8.533 3.821-8.533 8.533 0 4.713 3.821 8.533 8.533 8.533h25.6c4.713 0 8.533-3.821 8.533-8.533 0-4.713-3.82-8.533-8.533-8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_74_",
    d: "m238.933 375.467h-68.267c-4.713 0-8.533 3.821-8.533 8.533s3.821 8.533 8.533 8.533h68.267c4.713 0 8.533-3.82 8.533-8.533s-3.82-8.533-8.533-8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_73_",
    d: "m238.933 409.6h-68.267c-4.713 0-8.533 3.82-8.533 8.533s3.821 8.533 8.533 8.533h68.267c4.713 0 8.533-3.82 8.533-8.533s-3.82-8.533-8.533-8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_72_",
    d: "m349.867 375.467h-68.267c-4.713 0-8.533 3.821-8.533 8.533s3.82 8.533 8.533 8.533h68.267c4.713 0 8.533-3.82 8.533-8.533s-3.821-8.533-8.533-8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_71_",
    d: "m349.867 409.6h-68.267c-4.713 0-8.533 3.82-8.533 8.533s3.82 8.533 8.533 8.533h68.267c4.713 0 8.533-3.82 8.533-8.533s-3.821-8.533-8.533-8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_70_",
    d: "m460.8 375.467h-68.267c-4.713 0-8.533 3.821-8.533 8.533s3.82 8.533 8.533 8.533h68.267c4.713 0 8.533-3.82 8.533-8.533s-3.82-8.533-8.533-8.533z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_69_",
    d: "m460.8 409.6h-68.267c-4.713 0-8.533 3.82-8.533 8.533s3.82 8.533 8.533 8.533h68.267c4.713 0 8.533-3.82 8.533-8.533s-3.82-8.533-8.533-8.533z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserWindow);
export default __webpack_public_path__ + "static/media/browser-window.673ea53ce4cf75d7f644c5152e711e51.svg";
export { ForwardRef as ReactComponent };